export default "__VITE_ASSET__CK3gArib__"